export const bubbleParams = {
  bubbles: true,
  cancelable: true,
};
export const mouseEventBubble = new MouseEvent('click', bubbleParams);
export const mouseEventClientXY = new MouseEvent('click', {
  clientX: 100,
  clientY: 100,
});
export const transitionEndEvent = new Event('transitionend');

export const keyCodeForEnter = 13;

export const keyUpEnterEvent = new KeyboardEvent('keyup', {
  keyCode: keyCodeForEnter,
});

export let gsapToSpy;

export const transitionEndElement = (element) => {
  element[0].dispatchEvent(transitionEndEvent);
};

export const bubbleClickElement = (element) => {
  element[0].dispatchEvent(mouseEventBubble);
};

export const elementClientXYClick = (element) => {
  element[0].dispatchEvent(mouseEventClientXY);
};

export const elementKeyUpEnter = (element) => {
  element[0].dispatchEvent(keyUpEnterEvent);
};

export const setGsapToSpy = () => {
  gsapToSpy = jest.spyOn(gsap, 'to');
};

export const mockGsapToSpy = () => {
  gsapToSpy.mockImplementation((target, params) => {
    if (params.onComplete) {
      params.onComplete();
    }
  });
};

export const resetAllMocks = () => {
  jest.clearAllMocks();
  jest.restoreAllMocks();
};

export const removeEventListeners = (elements) => {
  elements.each((index, el) => {
    const noListenersEl = $(el).clone();
    $(el).replaceWith(noListenersEl);
  });
};
